/**
 * @ngdoc config
 * @name routeProviderConfig
 * @description
 * Sets the routes for the Upload section:
 * - The default one (`/`).
 *
 * @param {Service} $routeProvider The interface for the Angular router.
 * @memberof upload
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/upload/:id?', {
    template: ({ id = '' }) => `<upload campaign-id="${id}"></upload>`,
  });
};

export default routeProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/upload/configs/routeProvider.config.js